export const enum AnalyticsEvent {
  //InitApplication
  InitApplication = 'InitApplication / User initialized the application',

  //Authentication
  Authentication = 'Authentication',

  //Integrations
  OpenIntegrationsOverview = 'Integrations / Open Integrations Overview',

  //Report
  OpenReport = 'Report / Open report',
  PerformanceReportViewPdf = 'Performance Reports / View PDF',
  PerformanceReportDownloadPdf = 'Performance Reports / Download PDF',
  PerformanceReportFeedback = 'Performance Reports / Send feedback',

  //Demo
  OpenDemo = 'Demo / Open demo',
  OpenDemoPerformanceReports = 'Demo / Open performance reports',
  DemoPerformanceReportView = 'Demo / View performance report sample',
  DemoPerformanceReportDownload = 'Demo / Download performance report sample',
  DemoPerformanceReportRequest = 'Demo / Request performance report',

  OpenDemoIntegrations = 'Demo / Open integrations',
  DemoIntegrationsChangeTimezone = 'Demo / Change integrations timezone',
  OpenDemoIntegrationsLeadForm = 'Demo / Open integrations lead form',
  OpenDemoScheduler = 'Demo / Open scheduler',
  DemoSchedulerOpenForm = 'Demo / Open sample schedule form',
  DemoSchedulerCreateSchedule = 'Demo / Create sample schedule',
  OpenDemoSchedulerLeadForm = 'Demo / Open scheduler lead form',

  //Analytics MCP
  OpenAnalyticsMcp = 'Analytics MCP / Open preview page',
  RunAnalyticsMcpSample = 'Analytics MCP / Run sample question',
  OpenAnalyticsMcpLeadForm = 'Analytics MCP / Open lead form',

  //Assistant
  OpenAssistant = 'Assistant / Open page',
  OpenAssistantLeadForm = 'Assistant / Open lead form',
  AssistantSendMessage = 'Assistant / Send message',

  //PowerBI Embed events
  PBIEmbedEvent = 'PowerBIEmbedEvent / Power BI  embed event',

  //Scheduler events
  OpenSchedulerForm = 'Scheduler / Open scheduler form',
  SubmitSchedulerForm = 'Scheduler / Submit scheduler form',
  CancelSchedulerForm = 'Scheduler / Cancel scheduler form',
  SchedulerBlocked = 'Scheduler / Scheduler creation blocked',
  OpenLeadForm = 'Scheduler / Open lead form',
  SubmitLeadForm = 'Scheduler / Submit lead form',
  CancelLeadForm = 'Scheduler / Cancel lead form',
}
export type AnalyticsProperties = Record<string, unknown>
